var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFieldVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125 210",
    stroke: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0, -0.173474, 0.173474, 0, 0.087027, 199.628296)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1150,
    height: 720,
    fill: "#3BCE9D",
    id: "rect2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 575 20 L 50 20 L 50 700 L 1100 700 L 1100 20 L 575 20 L 575 700 Z",
    stroke: "white",
    strokeWidth: 2,
    fill: "#3BCE9D",
    id: "path4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575,
    cy: 360,
    r: 91.5,
    stroke: "white",
    strokeWidth: 2,
    fillOpacity: 0,
    id: "circle6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50 324.4 L 40 324.4 L 40 396.6 L 50 396.6 Z",
    stroke: "white",
    strokeWidth: 2,
    fillOpacity: 0,
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1100 324.4 L 1110 324.4 L 1110 396.6 L 1100 396.6 Z",
    stroke: "white",
    strokeWidth: 2,
    fillOpacity: 0,
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50 159.4 L 215 159.4 L 215 561.6 L 50 561.6 Z",
    stroke: "white",
    strokeWidth: 2,
    fillOpacity: 0,
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1100 159.4 L 935 159.4 L 935 561.6 L 1100 561.6 Z",
    stroke: "white",
    strokeWidth: 2,
    fillOpacity: 0,
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 215 286.875 C 263.667 323.479 263.667 396.521 215 433.125 Z",
    stroke: "white",
    strokeWidth: 2,
    fill: "#3BCE9D",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 935 286.875 C 886.333 323.479 886.333 396.521 935 433.125 Z",
    stroke: "white",
    strokeWidth: 2,
    fill: "#3BCE9D",
    id: "path28"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575,
    cy: 360,
    r: 2,
    stroke: "white",
    fill: "white",
    id: "circle8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 360,
    r: 2,
    stroke: "white",
    fill: "white",
    id: "circle10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 990,
    cy: 360,
    r: 2,
    stroke: "white",
    fill: "white",
    id: "circle12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50 269.4 L 105 269.4 L 105 451.6 L 50 451.6 Z",
    stroke: "white",
    strokeWidth: 2,
    fillOpacity: 0,
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1100 269.4 L 1045 269.4 L 1045 451.6 L 1100 451.6 Z",
    stroke: "white",
    strokeWidth: 2,
    fillOpacity: 0,
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50 30 C 55.523 30 60 25.523 60 20 L 50 20 Z",
    stroke: "white",
    strokeWidth: 2,
    fillOpacity: 0,
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60 700 C 60 694.477 55.523 690 50 690 L 50 700 Z",
    stroke: "white",
    strokeWidth: 2,
    fillOpacity: 0,
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1100 690 C 1094.477 690 1090 694.477 1090 700 L 1100 700 Z",
    stroke: "white",
    strokeWidth: 2,
    fillOpacity: 0,
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1090 20 C 1090 25.523 1094.477 30 1100 30 L 1100 20 Z",
    stroke: "white",
    strokeWidth: 2,
    fillOpacity: 0,
    id: "path36"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldVertical);
export default __webpack_public_path__ + "static/media/FieldVertical.29cd300573387f00f9d65cf597a451cc.svg";
export { ForwardRef as ReactComponent };